export var ReminderAction;
(function (ReminderAction) {
    ReminderAction[ReminderAction["EMAIL_APP"] = 1] = "EMAIL_APP";
    ReminderAction[ReminderAction["EMAIL"] = 2] = "EMAIL";
    ReminderAction[ReminderAction["APP"] = 3] = "APP";
})(ReminderAction || (ReminderAction = {}));
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["MIN"] = 1] = "MIN";
    TimeUnit[TimeUnit["HOUR"] = 2] = "HOUR";
    TimeUnit[TimeUnit["DAY"] = 3] = "DAY";
    TimeUnit[TimeUnit["WEEK"] = 4] = "WEEK";
    TimeUnit[TimeUnit["SECONDS"] = 5] = "SECONDS";
})(TimeUnit || (TimeUnit = {}));
export const LAST_SELECT_TIMEZONE_ID = 'LAST_SELECT_TIMEZONE_ID';
